import { render, staticRenderFns } from "./ListErrors.vue?vue&type=template&id=00014632&scoped=true"
import script from "./ListErrors.vue?vue&type=script&lang=js"
export * from "./ListErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00014632",
  null
  
)

export default component.exports